import React from 'react';

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        {/* Brand Section */}
        <div style={styles.section}>
          <div style={styles.logo}>
            <img src="/logo.jpg" alt="GlowFlex" style={styles.logoImg} />
            <div>
              <h3 style={styles.brandName}>GlowFlex</h3>
              <p style={styles.tagline}>SISTERS CLUB</p>
            </div>
          </div>
          <p style={styles.description}>
            Empowering women through fitness, wellness, and community.
          </p>
        </div>

        {/* Quick Links */}
        <div style={styles.section}>
          <h4 style={styles.sectionTitle}>Quick Links</h4>
          <a href="/activities" style={styles.link}>Activities</a>
          <a href="/menu" style={styles.link}>Menu</a>
          <a href="/contact" style={styles.link}>Contact</a>
        </div>

        {/* Contact Info */}
        <div style={styles.section}>
          <h4 style={styles.sectionTitle}>Contact</h4>
          <p style={styles.contactItem}>
            <a href="https://wa.me/254119008944" target="_blank" rel="noopener noreferrer" style={styles.link}>
              0119008944
            </a>
          </p>
          <p style={styles.contactItem}>
            <a href="mailto:glowflexsisters@gmail.com" style={styles.link}>
              glowflexsisters@gmail.com
            </a>
          </p>
        </div>

        {/* Social Media */}
        <div style={styles.section}>
          <h4 style={styles.sectionTitle}>Follow Us</h4>
          <div style={styles.socialLinks}>
            <a href="https://instagram.com/glowflex.ke" target="_blank" rel="noopener noreferrer" style={styles.socialLink}>
               Instagram
            </a>
            <a href="https://tiktok.com/@glowflex.ke" target="_blank" rel="noopener noreferrer" style={styles.socialLink}>
               TikTok
            </a>
            <a href="https://wa.me/254119008944" target="_blank" rel="noopener noreferrer" style={styles.socialLink}>
               WhatsApp
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div style={styles.bottomBar}>
        <p style={styles.copyright}>
          © 2025 GlowFlex Sisters Club
        </p>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    background: 'linear-gradient(135deg, #FFA8B9 0%, #FF85A1 100%)',
    color: '#2C2C2C',
    padding: '2rem 0 0',
    marginTop: '3rem'
  },
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '0 2rem',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '1.5rem',
    marginBottom: '1rem'
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem'
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    marginBottom: '0.5rem'
  },
  logoImg: {
    width: '45px',
    height: '45px',
    borderRadius: '50%',
    objectFit: 'cover'
  },
  brandName: {
    fontSize: '1.3rem',
    fontWeight: 700,
    color: '#3D6B29',
    margin: 0,
    fontFamily: 'Playfair Display, serif'
  },
  tagline: {
    fontSize: '0.75rem',
    color: '#3D6B29',
    fontWeight: 700,
    margin: 0
  },
  description: {
    color: '#2C2C2C',
    lineHeight: 1.4,
    fontSize: '0.85rem'
  },
  sectionTitle: {
    fontSize: '1rem',
    fontWeight: 700,
    color: '#3D6B29',
    marginBottom: '0.25rem'
  },
  link: {
    color: '#3D6B29',
    textDecoration: 'none',
    fontWeight: 600,
    transition: 'opacity 0.3s',
    fontSize: '0.85rem'
  },
  contactItem: {
    color: '#2C2C2C',
    margin: '0.15rem 0',
    fontSize: '0.85rem'
  },
  socialLinks: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem'
  },
  socialLink: {
    color: '#3D6B29',
    textDecoration: 'none',
    fontWeight: 600,
    fontSize: '0.9rem',
    transition: 'opacity 0.3s'
  },
  bottomBar: {
    borderTop: '2px solid rgba(122, 184, 69, 0.3)',
    padding: '1rem 2rem',
    textAlign: 'center'
  },
  copyright: {
    color: '#3D6B29',
    fontSize: '0.8rem',
    fontWeight: 600,
    margin: 0
  },
  '@media (max-width: 768px)': {
    container: {
      gridTemplateColumns: '1fr',
      gap: '1rem',
      padding: '0 1rem'
    },
    footer: {
      padding: '1.5rem 0 0'
    }
  }
};

export default Footer;